import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import type { WorkflowCreateInDto } from 'shared/domain/workflow/types';
import type { WorkflowCreateRequestModel } from '../httpQueue/workflow/requestRunner';

export interface AddWorkflowUseCase {
  execute(
    workflowCreateDto: WorkflowCreateInDto,
    projectId: string,
    uniqueId: string
  ): Promise<void>;
}

export class WorkflowSaver implements AddWorkflowUseCase {
  constructor(
    private addRequest: (request: WorkflowCreateRequestModel) => Promise<unknown>
  ) {}

  async execute(
    workflowCreateDto: WorkflowCreateInDto,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    debugLog('WorkflowSaver.execute', workflowCreateDto);
    const request: WorkflowCreateRequestModel = {
      createdAt: Date.now(),
      method: 'POST',
      url: `/project/${projectId}/workflow`,
      data: {
        workflowCreateDto,
        projectId,
        uniqueId,
      },
      entityType: HttpRequestModelType.workflow,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const workflowSaver = new WorkflowSaver(addRequest);
